import ActionTypes from './constants/action-types';
import ReadyState from './constants/ready-state';
import AuthState from './types/state';
import { RootActionTypes } from '../../stores/types';

const DefaultState: AuthState = {
  redirect: {
    status: ReadyState.PENDING,
  },
};

export default function (state = DefaultState, action: RootActionTypes): AuthState {
  switch (action.type) {
    case ActionTypes.AUTH_FORGOT_PASSWORD_COMPLETED:
      return { ...state, resetSent: true };

    case ActionTypes.AUTHORIZE_DOCS_COMPLETED:
      return { ...state, docs: action.payload };

    case ActionTypes.AUTHORIZE_REDIRECT_COMPLETED:
      return {
        ...state,
        redirect: {
          location: action.payload.redirect,
          status: ReadyState.FULFILLED,
        },
      };

    case ActionTypes.AUTHORIZE_REDIRECT_REQUEST:
      return {
        ...state,
        redirect: {
          location: undefined,
          status: ReadyState.LOADING,
        },
      };

    case ActionTypes.AUTHORIZE_REDIRECT_FAILURE:
      return {
        ...state,
        redirect: {
          status: ReadyState.REJECTED,
        },
      };

    default:
      return state;
  }
}
